import { maxBy, range } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import { Grid } from '@mui/material'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import Checkbox from '../../../../components/forms/Checkbox'
import DatePicker from '../../../../components/forms/DatePicker'
import NumberField from '../../../../components/forms/NumberField'
import Select from '../../../../components/forms/Select'
import Textarea from '../../../../components/forms/Textarea'
import { SANDRE } from '../../../../referencial/constants/ReferencialConstants'
import DtoSandreCode from '../../../../referencial/dto/DtoSandreCode'
import { getDefaultValuesChoiceModal, getMatTypes } from '../../../../utils/MaterielUtils'
import { getSandreList } from '../../../../utils/StoreUtils'
import { MATERIEL_STATE_REFORMED_ID } from '../../../constants/MaterielStateConstants'
import GenericReferencialDto from '../../../dto/GenericReferencialDto'
import PowerSupplyTypeDto from '../../powerSupply/dto/PowerSupplyTypeDto'
import CentralDto from '../dto/CentralDto'
import DtoCentralSituation from '../dto/DtoCentralSituation'


const CentralEquipmentPanel = ({
    central = {},
    centralTypes = [],
    active = false,
    disabled = true,
    centralSituations = [],
    powerSupplyTypes = [],
    telecomTypes = [],
    sandreCodes = [],
    displayDesiccant = true,
    onChange = () => { },
}) => {
    const lastSituation = maxBy(centralSituations, 'situationDate')

    return (
        <Grid size={12} sx={{ marginBottom: 1 }}>
            <Grid container spacing={1} sx={{ alignItems: 'center', paddingTop: '3px' }}>
                <Grid size={4}>
                    <Select
                        options={getMatTypes(centralTypes, central.centralType)}
                        label={i18n.type}
                        onChange={value => {
                            onChange({ centralType: value })
                            getDefaultValuesChoiceModal(centralTypes.find(c => c.materielType == value), onChange)
                        }}
                        value={central.centralType}
                        nullLabel='&nbsp;'
                        active={active}
                        disabled={disabled}
                    />
                </Grid>
                <Grid size={4}>
                    <Select
                        options={getMatTypes(telecomTypes, central.telecomType)}
                        label={i18n.typeTelecom}
                        onChange={value => onChange({ telecomType: value })}
                        value={central.telecomType}
                        nullLabel='&nbsp;'
                        active={active}
                        disabled={disabled}
                    />
                </Grid>
                <Grid size={4}>
                    <Select
                        options={getMatTypes(powerSupplyTypes, central.powerSupplyType)}
                        label={i18n.powerSupplyType}
                        onChange={value => onChange({ powerSupplyType: value })}
                        value={central.powerSupplyType}
                        nullLabel='&nbsp;'
                        active={active}
                        disabled={disabled}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={1} sx={{ alignItems: displayDesiccant ? 'center' : undefined, paddingTop: '3px' }}>
                <Grid size={4}>
                    <NumberField
                        title={i18n.batteryCount}
                        value={central.pileNumber}
                        onChange={value => onChange({ pileNumber: value })}
                        active={active}
                        disabled={disabled}
                    />
                </Grid>
                <Grid size={4}>
                    <NumberField
                        title={i18n.supplyTime}
                        value={central.supplyTime}
                        onChange={value => onChange({ supplyTime: value })}
                        active={active}
                        disabled={disabled}
                    />
                </Grid>
                {
                    displayDesiccant && (
                        <Grid size={4}>
                            <Checkbox
                                label={i18n.desiccant}
                                checked={central.desiccant === '1'}
                                onChange={value => onChange({ desiccant: value ? '1' : '0' })}
                                active={active}
                                disabled={disabled}
                            />
                        </Grid>
                    )
                }
            </Grid>
            <Grid container sx={{ paddingTop: '8px' }}>
                <Grid size={12}>
                    <Textarea
                        title={i18n.comment}
                        value={central.comment}
                        onChange={value => onChange({ comment: value })}
                        active={active}
                        disabled={disabled}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={1} sx={{ paddingTop: '8px' }}>
                <Grid size={4}>
                    <NumberField
                        title={i18n.transmissionVolume}
                        onChange={value => onChange({ transmissionVolume: parseInt(value) })}
                        value={parseInt(central.transmissionVolume)}
                        active={active}
                        disabled={disabled}
                    />
                </Grid>
                <Grid size={4}>
                    <Select
                        options={getSandreList(sandreCodes, SANDRE.CENTRALE_FREQUENCE_TRANSMISSION)}
                        label={i18n.sendingFrequency}
                        onChange={value => onChange({ callFrequency: parseInt(value) })}
                        value={parseInt(central.callFrequency)}
                        nullLabel='&nbsp;'
                        active={active}
                        disabled={disabled}
                    />
                </Grid>
                <Grid size={4}>
                    <Select
                        options={range(0, 24).map(h => ({ code: h, name: `${h}h` }))}
                        label={i18n.sendingTime}
                        onChange={value => onChange({ callHour: parseInt(value) })}
                        value={parseInt(central.callHour)}
                        nullLabel='&nbsp;'
                        active={active}
                        disabled={disabled}
                    />
                </Grid>
            </Grid>
            {
                !!lastSituation && lastSituation.statusCode === MATERIEL_STATE_REFORMED_ID && (
                    <Grid container sx={{ paddingTop: '0.8em' }}>
                        <Grid size={4}>
                            <DatePicker
                                onChange={(_, v) => onChange({ withdrawalDate: v })}
                                id='withdrawalDate'
                                title={i18n.withdrawalDate}
                                value={central.withdrawalDate}
                                active={active}
                                disabled={disabled}
                                startDate={central.purchaseDate}
                            />
                        </Grid>
                    </Grid>
                )
            }
        </Grid>
    )
}

CentralEquipmentPanel.propTypes = {
    disabled: PropTypes.bool,
    active: PropTypes.bool,
    isEquipment: PropTypes.bool,
    central: PropTypes.instanceOf(CentralDto),
    onChange: PropTypes.func,
    centralTypes: PropTypes.instanceOf(GenericReferencialDto),
    powerSupplyTypes: PropTypes.arrayOf(PropTypes.instanceOf(PowerSupplyTypeDto)),
    sandreCodes: PropTypes.arrayOf(PropTypes.instanceOf(DtoSandreCode)),
    centralSituations: PropTypes.arrayOf(PropTypes.instanceOf(DtoCentralSituation)),
    displayDesiccant: PropTypes.bool,
    telecomTypes: PropTypes.arrayOf(GenericReferencialDto),
}

const mapStateToProps = store => ({
    centralTypes: store.CentralReducer.centralTypes,
    powerSupplyTypes: store.PowerSupplyReducer.powerSupplyTypes,
    sandreCodes: store.ReferencialReducer.sandreCodes,
    centralSituations: store.CentralReducer.centralSituations,
    telecomTypes: store.TelecomReducer.telecomTypes,
})

export default connect(mapStateToProps)(CentralEquipmentPanel)
